import script from "./CardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSection.vue?vue&type=script&setup=true&lang=js"

import "./CardSection.vue?vue&type=style&index=0&id=4ffc93e4&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ffc93e4"]])

export default __exports__